import I18n from 'Pods/Shared/I18n'

export const EDIT_WITH_AI_LABEL = 'Edit with AI'

const ARCHIVE_FILE_KEY_PREFIX = 'profile.my_purchases.archive_file'

const translateArchiveFile = key => I18n.t(`${ARCHIVE_FILE_KEY_PREFIX}.${key}`, { ns: 'rails' })

export const buildArchiveFileLabels = () => ({
  title: translateArchiveFile('title'),
  description: translateArchiveFile('description'),
  listLabel: translateArchiveFile('list_label'),
  submit: translateArchiveFile('submit'),
  cancel: translateArchiveFile('cancel'),
})
